// Section for import npm components -----------------------------------------------------------------------------------
import React, { createContext, useState, useContext } from 'react';

// Section for type definition -----------------------------------------------------------------------------------------

type SelectedCities = number[] | [];
const initialSelectedCities: SelectedCities = [];

export const SelectedCitiesContext: React.Context<SelectedCities> =
  createContext<SelectedCities>(initialSelectedCities);

export const UpdateSelectedCities: React.Context<any> = createContext(initialSelectedCities);
// export const SelectedCitiesConsumer = SelectedCitiesContext.Consumer;
export const useSelectedCities = () => useContext(SelectedCitiesContext);
export const useUpdateSelectedCities = () => useContext(UpdateSelectedCities);

// Section for render component ----------------------------------------------------------------------------------------
function SelectedCitiesProvider(props: any): React.JSX.Element {
  const { children } = props;
  const [selectedCities, setSelectedCities] = useState([]);
  // valueにグローバルに扱う値を設定
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <SelectedCitiesContext.Provider value={selectedCities}>
      <UpdateSelectedCities.Provider value={setSelectedCities}>{children}</UpdateSelectedCities.Provider>
    </SelectedCitiesContext.Provider>
  );
}

export default SelectedCitiesProvider;
